import { makeStyles } from '@mui/styles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles(() => ({
  wrapper: {
    '& > *:not(:last-child)': {
      borderBottom: `1px solid ${colors.gray85}`,
    },
  },
  container: {
    height: '36px',
    alignItems: 'center',
  },
  property: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.25px',
    color: colors.gray15,
  },
  value: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.25px',
    color: colors.gray15,
  },
}));
